export const HOLDING_REPORT = "HOLDING_REPORT";
export const HOLDING_DATA_FLAGS = "HOLDING_DATA_FLAGS";
export const FILTER_DATA = "FILTER_DATA";
export const SORT_DATA = "SORT_DATA";
export const SUMMARIZE = "SUMMARIZE";
export const SEARCH = "SEARCH";
export const QUANTITY_BREAKDOWN = "QUANTITY_BREAKDOWN";
export const SCREENSTATE = "SCREENSTATE";
export const SELECTED_STOCK = "SELECTED_STOCK";
